class BundleBuilderProgressBar {
  constructor(rootEl) {
    this.root = rootEl;
    this.fill = rootEl.querySelector('.promo-progress-bar__fill');
  }

  init() {
    document.addEventListener('bundle:items-updated', (e) => this.handleUpdate(e));
    document.addEventListener('bundle:cart-loaded', () => {
      const totalCents = window.BundleState?.cartSubtotalCents || 0;
      this.updateUI(totalCents);
    });
  }

  handleUpdate(e) {
    const totalCents = e.detail.totalCombinedCents || 0;
    this.updateUI(totalCents);
  }

  calculateFillPercent(totalCents) {
    if (totalCents <= 0) return 0;
    if (totalCents < 4000) return (totalCents / 4000) * 20;
    if (totalCents < 6500) return 20 + ((totalCents - 4000) / 2500) * 30;
    if (totalCents < 9000) return 50 + ((totalCents - 6500) / 2500) * 30;
    if (totalCents < 10500) return 80 + ((totalCents - 9000) / 1500) * 20;
    return 100;
  }

  updateUI(totalCents) {
    const percent = this.calculateFillPercent(totalCents);
    if (this.fill) this.fill.style.width = percent + '%';
    this.updateMilestones(totalCents);
    this.updateMessage(totalCents);
  }

  updateMilestones(totalCents) {
    this.root.querySelectorAll('.promo-progress-bar__milestone').forEach(milestone => {
      const threshold = parseInt(milestone.dataset.threshold, 10);
      milestone.classList.toggle('is-reached', totalCents >= threshold);
    });
  }

  updateMessage(totalCents) {
    const messageEl = this.root.querySelector('.promo-progress-bar__message');
    if (!messageEl) return;
    const fmt = (cents) => {
      const euros = cents / 100;
      return euros % 1 === 0 ? euros + '€' : euros.toFixed(2).replace('.', ',') + '€';
    };
    const t = window.buddyTranslations?.progress;
    const replace = (tpl, amount) => tpl ? tpl.replace('__AMOUNT__', `<strong>${amount}</strong>`) : null;
    let html = '';
    if (totalCents < 4000) {
      html = replace(t?.messageShipping, fmt(4000 - totalCents))
        || `Plus que <strong>${fmt(4000 - totalCents)}</strong> pour avoir ta livraison gratuite`;
    } else if (totalCents < 6500) {
      html = replace(t?.message5, fmt(6500 - totalCents))
        || `Plus que <strong>${fmt(6500 - totalCents)}</strong> pour avoir -5% sur ta commande`;
    } else if (totalCents < 9000) {
      html = replace(t?.message10, fmt(9000 - totalCents))
        || `Plus que <strong>${fmt(9000 - totalCents)}</strong> pour avoir -10% sur ta commande`;
    } else {
      html = t?.messageComplete || 'Félicitations ! Tu as débloqué tous les avantages';
    }
    messageEl.innerHTML = html;
  }
}

function updateProgressBar(el) {
  if (!el || !window.BundleState) return;
  const tempBar = new BundleBuilderProgressBar(el);
  tempBar.updateUI(window.BundleState.cartSubtotalCents || 0);
}

function initAllProgressBars() {
  document.querySelectorAll('.promo-progress-bar').forEach(el => {
    if (!el.dataset.bundleProgressInitialized) {
      const bar = new BundleBuilderProgressBar(el);
      bar.init();
      el.dataset.bundleProgressInitialized = 'true';
    }
    updateProgressBar(el);
  });
}

function setupCartDrawerObserver() {
  const cartDrawer = document.querySelector('cart-drawer');
  if (!cartDrawer) return;

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType !== Node.ELEMENT_NODE) continue;
        const progressBars = node.matches?.('.promo-progress-bar')
          ? [node]
          : [...(node.querySelectorAll?.('.promo-progress-bar') || [])];

        progressBars.forEach(el => {
          delete el.dataset.bundleProgressInitialized;
          const bar = new BundleBuilderProgressBar(el);
          bar.init();
          el.dataset.bundleProgressInitialized = 'true';
          updateProgressBar(el);
        });
      }
    }
  });

  observer.observe(cartDrawer, { childList: true, subtree: true });
}

document.addEventListener('DOMContentLoaded', () => {
  initAllProgressBars();
  setupCartDrawerObserver();
});
document.addEventListener('product:rendered', initAllProgressBars);
document.documentElement.addEventListener('cart:change', () => {
  setTimeout(initAllProgressBars, 200);
});
